import httpService from "./httpService";
import { Sample } from "../utils/types";
import { utils } from "../utils";

export const createSample = async (sample: Sample) => {
	const { data } = await httpService.post(`/samples`, sample);
	return data;
};

export const search = async (params?: any) => {
	const bodyParams: any = httpService.parseBodyParams(params);

	const { data } = await httpService.post(`/samples/search`, bodyParams, {
		params: { skip: params.skip, limit: params.limit },
	});
	return data;
};

export const searchByGenders = async (params?: any, cancelToken?: any) => {
	const bodyParams: any = httpService.parseBodyParams(params);

	if (params.genders?.length > 0) {
		bodyParams.categories = null;
	}

	const { data } = await httpService.post(`/samples/gender/search`, bodyParams, {
		cancelToken,
		params: { skip: params.skip, limit: params.limit },
	});
	return data;
};

export const searchDownload = async (params?: any, cancelToken?: any) => {
	try {
		const bodyParams: any = {};
		Object.keys(params).forEach((key) => {
			if (!Array.isArray(params[key])) {
				bodyParams[key] = params[key];
			} else if (params[key].length > 0) {
				bodyParams[key] = params[key].map((value) => value.id);
			}
		});

		if (params.genders?.length > 0) {
			bodyParams.categories = null;
		}

		const response = await httpService.post(`/samples/search/download`, bodyParams, {
			cancelToken,
			params: { skip: params.skip, limit: params.limit },
			responseType: "blob",
		});

		utils.saveFile(response.data, `result-${new Date().toLocaleDateString("es-ES").replace(/\//g, "-")}.csv`);
	} catch (error) {
		console.error(error);
		throw new Error("No se pudo descargar el archivo.");
	}
};

export const getSample = async (id: string) => {
	const { data } = await httpService.get(`/samples/${id}`);
	return data;
};

export const deleteSample = async (id: string | number) => {
	const { data } = await httpService.delete(`/samples/${id}`);
	return data;
};

export const uploadFile = async (file: any) => {
	const { data } = await httpService.post(`/samples/massive`, file, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return data;
};

export const downloadTemplate = async () => {
	try {
		const response = await httpService.get(`/samples/massive/template`, {
			responseType: "blob",
		});

		utils.saveFile(response.data, "template.csv");
	} catch (error) {
		console.error(error);
		throw new Error("No se pudo descargar el archivo.");
	}
};

export const updateSample = async (sample: any) => httpService.put(`/samples/${sample.id}`, sample);
